export const oneOnOneTopicsSelector = state => state.oneOnOneTopics;
